module.exports = __webpack_public_path__ + "static/media/sand-clock.a62cd0a5.svg";